'use client'

import { notify } from '@/lib/notifications'

export function ContactsTab() {
  return (
    <div>
      <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">Contact Manager</h3>
      <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 sm:p-6">
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Manage your personal and emergency contacts. This feature helps us reach the right people in case of emergencies or important communications.
        </p>

        <div className="space-y-4">
          <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4">
            <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-2">Emergency Contacts</h4>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">Add emergency contacts who can be reached in case of urgent situations.</p>
            <button
              onClick={() => notify.info('Coming soon')}
              className="px-4 py-2 bg-[var(--theme-primary)] text-white rounded-md hover:bg-[var(--theme-primary-dark)] focus:outline-none focus:ring-2 focus:ring-[var(--theme-primary)]"
            >
              Add Emergency Contact
            </button>
          </div>

          <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4">
            <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-2">Personal Contacts</h4>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">Manage your personal contact list for quick communication.</p>
            <button
              onClick={() => notify.info('Coming soon')}
              className="px-4 py-2 bg-[var(--theme-primary)] text-white rounded-md hover:bg-[var(--theme-primary-dark)] focus:outline-none focus:ring-2 focus:ring-[var(--theme-primary)]"
            >
              Manage Contacts
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
